import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    VatCodeLineGridObject, VatCodeLineObject,
} from '@libs/types/src/mado/object-type/organization';
import { filterFrag } from './types/filter.types';
import { VatCodeLineCreateInput, VatCodeLineUpdateInput } from '@libs/types/src/mado/input-type/organization';

@Injectable({ providedIn: 'root' })
export class VatCodeLineGqlService extends GqlServiceV2 {

    public getVatCodeLines(input: GridInput | null, frag: string) {
        return this.query<VatCodeLineGridObject>(
            `
                query($input: GridInput!) {
                    vatCodeLine {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createVatCodeLine(input: VatCodeLineCreateInput, frag: string) {
        return this.mutate<VatCodeLineObject>(
            `
                mutation($input: VatCodeLineCreateInput!) {
                    vatCodeLine {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateVatCodeLine(input: VatCodeLineUpdateInput, frag: string) {
        return this.mutate<VatCodeLineObject>(
            `
                mutation($input: VatCodeLineUpdateInput!) {
                    vatCodeLine {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
